import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { modalWindows, auth } from '../../actions';
import PropTypes from 'prop-types';
import './Header.scss';
import eyes from '../footer/img/eyes.svg';
import { Mixpanel } from '../Mixpanel';


class Header extends Component {
  state = {
    accountBtnListIsHidden: true,
    burgerMenuOpen: false,
    miniNavWrapper: false
  }

  accountBtnToggle = () => {
    this.setState(state => ({
      accountBtnListIsHidden: !state.accountBtnListIsHidden
    }))
  
  }
  burgerBtnToggle = () => {
    this.setState(state => ({
      burgerMenuOpen: !state.burgerMenuOpen,
      miniNavWrapper: !state.miniNavWrapper,
    }));
  }

  toShop = () => {
     this.burgerBtnToggle()
     Mixpanel.track('To shop')
  }

  toNews = () => {
     this.burgerBtnToggle()
     Mixpanel.track('To news')
  }

  toAbout = () => {
     this.burgerBtnToggle()
     Mixpanel.track('To about')
  }

  render() {
    return (
      <header className='header'>
        <Link className='header__logo' to='/hackathons'></Link>
        <div className={this.state.miniNavWrapper ? 'navigation-wrapper open' : 'navigation-wrapper'}>
          <Link onClick={this.burgerBtnToggle} className='navigation-item' to='/hackathons'>хакатоны</Link>
          {/* <Link onClick={this.burgerBtnToggle} className='navigation-item' to='/ratings'>рейтинги</Link> */}
          <a href="https://news.russianhackers.org" onClick={this.toNews} className='navigation-item' target="_blank" rel="noopener noreferrer">новости</a>
          <a href="https://vc.ru/tribuna/128976" onClick={this.toShop} className='navigation-item' target="_blank" rel="noopener noreferrer">платформа для хакатонов</a>
          <a href="https://about.russianhackers.org" onClick={this.toAbout} className='navigation-item' target="_blank" rel="noopener noreferrer">о нас</a>
          {
            this.props.isAuthenticated && (
              <div className="account-btn" onClick={this.accountBtnToggle}>
                <div className="account-btn__img">
                  <img src={eyes} width="35" height="35" alt="eyes"/>
                </div>
                <div className="account-btn__username">{this.props.userName}
                  <div className={this.state.accountBtnListIsHidden ? "account-actions-list account-actions-list_hidden" : 'account-actions-list'}>
                    <Link to='/account'><div onClick={this.burgerBtnToggle} className="account-actions-list__profile">Профиль</div></Link>
                    <div onClick={this.props.logoutUser} className="account-actions-list__profile">Выйти</div>
                  </div>
                </div>

              </div>
            )
          }
          {
            !this.props.isAuthenticated && (
              <button className='navigation-item navigation-item_button'
                onClick={this.props.openLoginModal}>
                ВОЙТИ
            </button>
            ) 
          }
        </div>

        <div id="mini-menu-toggle" onClick={this.burgerBtnToggle} className={this.state.burgerMenuOpen ? 'open' : ''}>
          <div id="hamburger">
            <span className="hamburger-span"></span>
            <span className="hamburger-span"></span>
            <span className="hamburger-span"></span>
          </div>
          <div id="cross">
            <span className="hamburger-span"></span>
            <span className="hamburger-span"></span>
          </div>
      </div>

      </header>
    );
  }
}

Header.propTypes = {
  loginModalOpened: PropTypes.bool.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  userName: PropTypes.string.isRequired,
  openLoginModal: PropTypes.func.isRequired,
  logoutUser: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
  return {
    isAuthenticated: state.auth.isAuthenticated,
    loginModalOpened: state.modalWindows.loginOpened,
    userName: state.user.username,
  };
}
export default connect(mapStateToProps, {
  openLoginModal: modalWindows.openLoginModal,
  logoutUser: auth.logout,
})(Header);




// WEBPACK FOOTER //
// ./src/components/Header/index.js